__turbopack_context__.v({
  "bar": "Header-module__lnUIdW__bar",
  "barOpen1": "Header-module__lnUIdW__barOpen1",
  "barOpen2": "Header-module__lnUIdW__barOpen2",
  "barOpen3": "Header-module__lnUIdW__barOpen3",
  "chevron": "Header-module__lnUIdW__chevron",
  "container": "Header-module__lnUIdW__container",
  "dropHeader": "Header-module__lnUIdW__dropHeader",
  "dropHeaderTitle": "Header-module__lnUIdW__dropHeaderTitle",
  "dropItem": "Header-module__lnUIdW__dropItem",
  "dropItemDesc": "Header-module__lnUIdW__dropItemDesc",
  "dropItemIcon": "Header-module__lnUIdW__dropItemIcon",
  "dropItemLabel": "Header-module__lnUIdW__dropItemLabel",
  "ecosystemDropdown": "Header-module__lnUIdW__ecosystemDropdown",
  "featuresDropdown": "Header-module__lnUIdW__featuresDropdown",
  "featuresMegaMenu": "Header-module__lnUIdW__featuresMegaMenu",
  "hamburger": "Header-module__lnUIdW__hamburger",
  "header": "Header-module__lnUIdW__header",
  "hubBox": "Header-module__lnUIdW__hubBox",
  "iconDropItem": "Header-module__lnUIdW__iconDropItem",
  "legacySolutionsLinks": "Header-module__lnUIdW__legacySolutionsLinks",
  "linkColumn": "Header-module__lnUIdW__linkColumn",
  "linksColumns": "Header-module__lnUIdW__linksColumns",
  "logo": "Header-module__lnUIdW__logo",
  "logoContainer": "Header-module__lnUIdW__logoContainer",
  "megaMenuContainer": "Header-module__lnUIdW__megaMenuContainer",
  "megaMenuWrapper": "Header-module__lnUIdW__megaMenuWrapper",
  "mobileCta": "Header-module__lnUIdW__mobileCta",
  "moduleGrid": "Header-module__lnUIdW__moduleGrid",
  "moduleGridSingle": "Header-module__lnUIdW__moduleGridSingle",
  "moduleIcon": "Header-module__lnUIdW__moduleIcon",
  "moduleLink": "Header-module__lnUIdW__moduleLink",
  "moduleSectionTitle": "Header-module__lnUIdW__moduleSectionTitle",
  "modulesContent": "Header-module__lnUIdW__modulesContent",
  "nav": "Header-module__lnUIdW__nav",
  "navContainer": "Header-module__lnUIdW__navContainer",
  "navItem": "Header-module__lnUIdW__navItem",
  "navItemActive": "Header-module__lnUIdW__navItemActive",
  "navItemContent": "Header-module__lnUIdW__navItemContent",
  "navOpen": "Header-module__lnUIdW__navOpen",
  "promoBox": "Header-module__lnUIdW__promoBox",
  "solutionsMegaMenu": "Header-module__lnUIdW__solutionsMegaMenu",
});
